import { Table } from "@mantine/core";
import { StyledTd, StyledTh } from "src/styled";

interface IVerificationSignature {
  idata: string;
  title: string;
}

const VerificationSignature = ({ idata, title }: IVerificationSignature) => {
  return (
    <Table
      style={{ width: "fit-content", maxWidth: "500px", overflowX: "scroll" }}>
      <tr>
        <StyledTh>{title}</StyledTh>
      </tr>
      <tr>
        <StyledTd style={{ padding: 10 }}>
          <img id="signature-img" height={"100px"} src={idata}></img>
        </StyledTd>
      </tr>
    </Table>
  );
};

export default VerificationSignature;
